"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var base_1 = require("@bhtp-client-api/base");
var rxjs_1 = require("rxjs");
var models_1 = require("./models");
var BhtpBaseTypeaheadService = (function (_super) {
    __extends(BhtpBaseTypeaheadService, _super);
    function BhtpBaseTypeaheadService() {
        var _this = _super.call(this) || this;
        _this.config = new models_1.TypeaheadConfig();
        return _this;
    }
    BhtpBaseTypeaheadService.prototype.exchangeSubscription = function (input, cancel) {
        var _this = this;
        var results = rxjs_1.Observable.create(function (resultsObserver) {
            var pending = [];
            if (cancel) {
                cancel.subscribe(function () {
                    if (pending.length >= 1) {
                        cancelSubs(pending.splice(0, pending.length));
                    }
                });
            }
            if (input) {
                input.subscribe(function (inputValue) {
                    var newSearch = _this.search(inputValue);
                    // HACK(ish) Wrap in timeout to make sure this is async. We need to
                    // get the subscription into the "pending" list before this resolves.
                    var newSearchSub = newSearch.subscribe(function (result) {
                        window.setTimeout(function () {
                            var observableIndex = pending.indexOf(newSearchSub);
                            if (observableIndex >= 0) {
                                resultsObserver.next(result);
                                cancelSubs(pending.splice(0, observableIndex + 1));
                            }
                        });
                    }, function (error) {
                        window.setTimeout(function () {
                            var observableIndex = pending.indexOf(newSearchSub);
                            pending.splice(observableIndex, 1);
                            resultsObserver.next([]);
                            console.warn("Failed to find matches for " + inputValue);
                        });
                    });
                    pending.push(newSearchSub);
                }, function (e) {
                    console.error(e);
                });
            }
            else {
                throw new Error('No input Observable provided, can not continue');
            }
        });
        // Subscribe to results right away, so cancel/input subscriptions get set up
        results.subscribe();
        return results;
        function cancelSubs(subsToCancel) {
            if (subsToCancel) {
                subsToCancel.forEach(function (subscription) {
                    subscription.unsubscribe();
                });
            }
        }
    };
    return BhtpBaseTypeaheadService;
}(base_1.BhtpBaseService));
BhtpBaseTypeaheadService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [])
], BhtpBaseTypeaheadService);
exports.BhtpBaseTypeaheadService = BhtpBaseTypeaheadService;
//# sourceMappingURL=D:/a/1/s/typeahead/src/base-typeahead-service.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/typeahead/src/base-typeahead-service.js